import React from "react";
import type { SeoFaqItem } from "../seo/faqContent";

type CrosshairFaqProps = {
    idPrefix: string;
    heading: string;
    items: SeoFaqItem[];
};

export function CrosshairFaq({ idPrefix, heading, items }: CrosshairFaqProps) {
    const headingId = `${idPrefix}-faq-heading`;

    return (
        <section className="cc-faq text-start" aria-labelledby={headingId}>
            <h2 id={headingId} className="cc-faq__title">
                {heading}
            </h2>
            <div className="cc-faq__list">
                {items.map((item, index) => {
                    const panelId = `${idPrefix}-faq-panel-${index}`;
                    const labelId = `${idPrefix}-faq-label-${index}`;
                    return (
                        <details key={labelId} className="cc-faq__item">
                            <summary className="cc-faq__summary" id={labelId}>
                                {item.question}
                            </summary>
                            <div className="cc-faq__answer" id={panelId} role="region" aria-labelledby={labelId}>
                                <p>{item.answer}</p>
                            </div>
                        </details>
                    );
                })}
            </div>
        </section>
    );
}
